import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { AssistantExamResponse, ExamFile } from '../../../types/Exams';
import { getCrmExaminationsTableColumns } from '../../../data/formsAndTable/tables/dataTables/DataSource';
import AjaxSourcedData from '../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import {
  useLeadGetExaminationsQuery,
  useRecountTranscriptsMutation,
} from '../../../reduxToolkit/reducers/usersSlice';
import { useEffect, useState } from 'react';
import { baseLang } from '../../../lib/utils';
import CommonCardHeader from '../../../coreComponents/CommonCardHeader';
import Swal from 'sweetalert2';
import Loader from '../../../layout/Loader';
import Error404 from '../../pages/others/errorPage/Error404';
import { NoDataComponent } from '../../formsAndTable/forms/formControls/NoDataComponent';
type Props = {
  handleModalOpen: (
    exam_id: number,
    examComment: string,
    detailsId: number | null,
    files: ExamFile[] | null | undefined,
  ) => void;
  setTabsTotals: React.Dispatch<
    React.SetStateAction<{ unset: number; future: number; past: number }>
  >;
};
const PastExaminations = ({ handleModalOpen, setTabsTotals }: Props) => {
  const { t, i18n } = useTranslation();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(50);
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');
  const [sortKey, setSortKey] = useState('examDate');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const pageLang = baseLang(i18n.language);
  const [recount] = useRecountTranscriptsMutation();

  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(id);
  }, [search]);
  const {
    data: pastExams,
    isLoading,
    isFetching,
    isError,
  } = useLeadGetExaminationsQuery({
    scope: 'past',
    page,
    perPage,
    sort,
    sortKey,
    search: debouncedSearch,
  });

  useEffect(() => {
    if (pastExams) {
      setTotalRows(pastExams.total);
      setTabsTotals((prev) => ({ ...prev, past: pastExams.total }));
    }
  }, [pastExams]);

  // Show full-page loader only on initial load (no data yet). For subsequent
  // fetches (pagination/search) keep the table mounted and show inline progress.
  const initialLoading = isLoading && !pastExams;
  if (isError) return <Error404 />;
  return (
    <>
      <CardBody>
        {initialLoading ? (
          <Loader />
        ) : (
          pastExams && (
            <AjaxSourcedData
              //  key={"past"}
              data={pastExams.items}
              columns={getCrmExaminationsTableColumns(
                t,
                viewerTz,
                'past',
                pageLang,
                handleModalOpen,
              )}
              pagination={true}
              paginationServer={true}
              paginationPerPage={perPage}
              paginationDefaultPage={page}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage, p) => {
                setPerPage(newPerPage);
                setPage(1); // or p, depending on your UX
              }}
              /* (optional) server sorting */
              sortServer
              onSort={(column, direction) => {
                // column.selector or column.sortField depending on your column defs
                const key = (column as any).sortField ?? (column as any).selector;
                setSort(direction);
                setSortKey(key);
              }}
              defaultSortAsc={false}
              searchServer
              searchText={search}
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
              // conditionalRowStyles={conditionalRowStyles}
              paginationRowsPerPageOptions={[10, 25, 50]}
              noDataComponent={<NoDataComponent />}
              // show inline progress when fetching subsequent pages
              progressPending={isFetching}
            />
          )
        )}
      </CardBody>

      {/* </Card> */}
    </>
  );
};
export default PastExaminations;
